import { get } from 'lodash-es';
/* Constants */
import { CTA_TYPE } from 'site-modules/shared/constants/inventory/lead-form';
/* Utils */
import { isUsed } from 'site-modules/shared/utils/inventory-utils/is-used';
import { isPartnerDealer } from 'site-modules/shared/utils/dealer-details-utils';
import { getVdpCtas } from 'site-modules/shared/utils/inventory/get-vdp-ctas';

/**
 * Checks if Deal Check can be shown.
 * @param {object} vehicle
 * @param {object} [location]
 * @return {boolean}
 */
export const isUsedDealCheckAvailable = (vehicle, location) => {
  const displayPrice = get(vehicle, 'prices.advertisedPrice');
  const ctas = getVdpCtas({ vinData: vehicle, location });
  const { maxGreatPrice, maxGoodPrice, maxFairPrice } = get(vehicle, 'computedDisplayInfo.priceValidation', {});

  return !!(
    isUsed(vehicle.type) &&
    displayPrice &&
    isPartnerDealer(vehicle) &&
    (maxGreatPrice || maxGoodPrice || maxFairPrice) &&
    ctas.length &&
    ctas.some(cta => cta !== CTA_TYPE.CALL_DEALER)
  );
};

/**
 * Checks if Deal Check can be shown for used non-partner dealers.
 * @param {object} vehicle
 * @return {boolean}
 */
export const isUsedNonPartnerDealerDealCheckAvailable = vehicle => {
  const displayPrice = get(vehicle, 'prices.advertisedPrice');
  const { maxGreatPrice, maxGoodPrice, maxFairPrice } = get(vehicle, 'computedDisplayInfo.priceValidation', {});

  return !!(
    isUsed(vehicle.type) &&
    displayPrice &&
    !isPartnerDealer(vehicle) &&
    (maxGreatPrice || maxGoodPrice || maxFairPrice)
  );
};
